/* AMP3 cookie banner (snippets/amp3-cookie-banner.liquid), Joshua 10 Oct 2026.
   Records the visitor's choice through Shopify's Customer Privacy API, so Shopify, Google, Brevo and
   the apps follow it as they did with Shopify's banner. Shows only when Shopify says this visitor
   needs a banner (UK region kept in admin) and hasn't chosen yet. If the API can't load, nothing
   shows and nothing non-essential runs. Accept and Decline are equal; Choose opens the switches.
   The footer's "Cookie settings" ([data-a3-cookie-settings]) reopens it with the current choices.
   ?a3cc-preview shows it even when it's switched off. */
(function () {
  'use strict';
  var bar = document.getElementById('a3-cookies');
  if (!bar) return;
  // The address the page was opened with: the theme swaps the query for ?variant=… on product pages.
  var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
  var preview = /[?&]a3cc-preview(=|&|#|$)/.test(location.search + ' ' + ((nav && nav.name) || ''));
  if (bar.dataset.enabled !== 'true' && !preview) { bar.remove(); return; }

  var root = document.documentElement;
  root.classList.add('a3-own-cookies'); // hides Shopify's own banner (CSS)
  var choices = bar.querySelector('.a3-cookies__choices');
  var chooseBtn = bar.querySelector('[data-a3-cc="choose"]');
  var KINDS = ['preferences', 'analytics', 'marketing'];

  function withApi(cb) {
    var shop = window.Shopify;
    if (shop && shop.customerPrivacy && shop.customerPrivacy.setTrackingConsent) { cb(shop.customerPrivacy); return; }
    if (!shop || !shop.loadFeatures) return;
    shop.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err && window.Shopify.customerPrivacy) cb(window.Shopify.customerPrivacy);
    });
  }
  function current(cp) {
    var c = {};
    try { c = cp.currentVisitorConsent() || {}; } catch (err) { /* older API */ }
    return c;
  }
  function undecided(cp) {
    var c = current(cp);
    return KINDS.some(function (k) { return c[k] !== 'yes' && c[k] !== 'no'; });
  }

  function openChoices(open) {
    choices.hidden = !open;
    chooseBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function show(withChoices, focus) {
    withApi(function (cp) {
      var c = current(cp);
      KINDS.forEach(function (k) { bar.querySelector('[name="' + k + '"]').checked = c[k] === 'yes'; });
    });
    openChoices(!!withChoices);
    bar.hidden = false;
    root.classList.add('a3-cookies-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { bar.classList.add('is-visible'); }); });
    if (focus) (withChoices ? bar.querySelector('[name="preferences"]') : bar.querySelector('[data-a3-cc="accept"]')).focus();
  }
  function hide() {
    if (bar.contains(document.activeElement)) document.activeElement.blur();
    bar.classList.remove('is-visible');
    root.classList.remove('a3-cookies-open');
    setTimeout(function () { if (!bar.classList.contains('is-visible')) bar.hidden = true; }, 300);
  }
  function decide(consent) {
    hide();
    withApi(function (cp) { cp.setTrackingConsent(consent, function () { /* Shopify fires visitorConsentCollected */ }); });
  }

  bar.addEventListener('click', function (e) {
    var b = e.target.closest('[data-a3-cc]');
    if (!b) return;
    var what = b.dataset.a3Cc;
    if (what === 'accept') decide({ analytics: true, marketing: true, preferences: true });
    else if (what === 'decline') decide({ analytics: false, marketing: false, preferences: false });
    else if (what === 'choose') openChoices(choices.hidden);
    else if (what === 'save') {
      var c = {};
      KINDS.forEach(function (k) { c[k] = bar.querySelector('[name="' + k + '"]').checked; });
      decide(c);
    }
  });

  // "Cookie settings" anywhere on the page.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-a3-cookie-settings]');
    if (!link) return;
    e.preventDefault();
    show(true, true);
  });

  if (preview) { setTimeout(function () { show(false, false); }, 600); return; }
  withApi(function (cp) {
    var needed = false;
    try { needed = cp.shouldShowBanner() && undecided(cp); } catch (err) { needed = false; }
    if (needed) setTimeout(function () { show(false, false); }, 600);
  });
})();
